export const ROUTE_STATE_CHANGES = 'ROUTE_STATE_CHANGES';

export function routerStateChange(state) {
  return {
    type: ROUTE_STATE_CHANGES,
    state
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/routing/actions.js
 **/